import React from 'react';
import useAnalyticsPage from '../../web-analytics/hooks/useAnalyticsPage';
import { Page } from '../../web-analytics/Page';
import { SocialMediaIntegrations } from '../../social-posting/components/SocialMediaIntegrations';

export const TeamIntegrations = () => {
  useAnalyticsPage(Page.INTEGRATIONS);

  return (
    <div className="integrations__wrapper">
      <SocialMediaIntegrations />
    </div>
  );
};
